import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

const supportedLanguages = ["en", "sv", "da", "fi"] as const;
const defaultLanguage = "en";

function getInitialLanguage() {
  if (typeof navigator === "undefined") {
    return defaultLanguage;
  }

  const browserLanguages = [...navigator.languages, navigator.language].filter(
    (language): language is string => typeof language === "string" && language.length > 0,
  );

  for (const language of browserLanguages) {
    const normalizedLanguage = language.toLowerCase();
    if (supportedLanguages.includes(normalizedLanguage as (typeof supportedLanguages)[number])) {
      return normalizedLanguage;
    }

    const baseLanguage = normalizedLanguage.split("-")[0];
    if (supportedLanguages.includes(baseLanguage as (typeof supportedLanguages)[number])) {
      return baseLanguage;
    }
  }

  return defaultLanguage;
}

i18n
  .use(Backend) // load translations using http (default public/locales)
  .use(initReactI18next) // pass the i18n instance to react-i18next
  .init({
    lng: getInitialLanguage(),
    fallbackLng: "en",
    supportedLngs: supportedLanguages,
    debug: true,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      loadPath: "/locales/{{lng}}-translation.json",
    },
  });

export default i18n;
